import { Edge, Node } from '../../types';

export enum ChartEntity {
  NODE = 'tile',
  EDGE = 'connection', // internally this is an edge, customer facing is a connection.
}

export enum NodeAction {
  Clone = 'duplicate',
  Delete = 'delete',
}

type Item = Node | Edge;

/** Wraps calls to either `generateTitle` or  generateBody` (below) to generate modal text */
export const createContentFor = (
  func: (count: number, chartEntity: ChartEntity, action: NodeAction) => string | React.ReactNode,
  items: Partial<Item>[],
  chartEntity: ChartEntity,
  action: NodeAction,
) => func(items.length, chartEntity, action);

export const generateTitle = (count: number, chartEntity: ChartEntity, action: NodeAction) => {
  const entity = count > 1 ? `${chartEntity}s` : chartEntity;
  const capitalizedAction = action[0].toUpperCase() + action.slice(1);

  return `${capitalizedAction} ${entity}`;
};

export const generateBody = (count: number, chartEntity: ChartEntity, action: NodeAction) => {
  const entity = count > 1 ? `${chartEntity}s` : chartEntity;
  const qualifier = count > 1 ? 'these' : 'this';
  const quantity = count > 1 ? count : '';

  return (
    <>
      {`Are you sure you want to ${action} ${qualifier} `}
      <strong>{`${quantity} ${entity}`}</strong>?
    </>
  );
};

export const generateToastText = (
  action: string,
  chartEntity: ChartEntity,
  selectedItems: Partial<Item>[],
) => {
  const numItems = selectedItems.length;

  return `${numItems} ${chartEntity}${numItems > 1 ? 's' : ''} successfully ${action}d`;
};
